import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateListResource } from '../../../../lib/query/invalidateResource';
import { notification } from 'antd';
import { deleteCustomerSegment } from '../api/customerSegments';

export function useDeleteCustomerSegment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => deleteCustomerSegment(id),
    onSuccess: () => {
      notification.success({ message: 'Customer segment deleted' });
      invalidateListResource(queryClient, 'customer-segments');
      void queryClient.invalidateQueries({ queryKey: ['settings-contact-categories'] });
      void queryClient.invalidateQueries({ queryKey: ['contact-categories'] });
    },
    onError: () => {
      notification.error({ message: 'Failed to delete customer segment' });
    },
  });
}
